function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_28",
  "data-name": "Group 28",
  transform: "translate(-1695 -1985)"
}, React.createElement("rect", {
  id: "Rectangle_16",
  "data-name": "Rectangle 16",
  width: 100,
  height: 100,
  rx: 12,
  transform: "translate(1695 1985)",
  fill: "#0e76a8"
}), React.createElement("path", {
  id: "Path_47",
  "data-name": "Path 47",
  d: "M8.87-35.9A5.587,5.587,0,0,1,4.9-37.342,4.633,4.633,0,0,1,3.36-40.869,4.468,4.468,0,0,1,4.9-44.381,5.773,5.773,0,0,1,8.87-45.743a5.759,5.759,0,0,1,3.981,1.362,4.488,4.488,0,0,1,1.529,3.512A4.615,4.615,0,0,1,12.851-37.3,5.682,5.682,0,0,1,8.87-35.9ZM13.593,0H4.026V-31h9.566ZM51.586,0H42.05V-17.226q0-7.205-5.146-7.205a5.106,5.106,0,0,0-4.087,1.907,7.266,7.266,0,0,0-1.6,4.844V0H21.646V-31h9.566v4.9h.121a10.962,10.962,0,0,1,9.96-5.661q10.293,0,10.293,12.775Z",
  transform: "translate(1721 2056)",
  fill: "#fff"
}));

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin.2242a81a.svg";
export { ForwardRef as ReactComponent };